export enum PriceListCategory {

    // Special Case
    Catalogue = 'Catalogue',

    Customer = 'Customer',
    Contractor = 'Contractor',
    Supplier = 'Supplier'
}
